import { render, staticRenderFns } from "./DIscoverSellers.vue?vue&type=template&id=5434c665&"
import script from "./DIscoverSellers.vue?vue&type=script&lang=js&"
export * from "./DIscoverSellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports